const cities = [
  {
      "id": 1,
      "name": "臺北市",
      "is_supported": 1,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 2,
      "name": "新北市",
      "is_supported": 1,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 3,
      "name": "桃園市",
      "is_supported": 1,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 4,
      "name": "臺中市",
      "is_supported": 1,
      "fk_region_id": 2,
      "region": {
          "id": 2,
          "name": "中部",
          "no": "C"
      }
  },
  {
      "id": 5,
      "name": "高雄市",
      "is_supported": 1,
      "fk_region_id": 3,
      "region": {
          "id": 3,
          "name": "南部",
          "no": "S"
      }
  },
  {
      "id": 6,
      "name": "臺南市",
      "is_supported": 1,
      "fk_region_id": 3,
      "region": {
          "id": 3,
          "name": "南部",
          "no": "S"
      }
  },
  {
      "id": 7,
      "name": "基隆市",
      "is_supported": 0,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 8,
      "name": "新竹市",
      "is_supported": 0,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 9,
      "name": "嘉義市",
      "is_supported": 0,
      "fk_region_id": 3,
      "region": {
          "id": 3,
          "name": "南部",
          "no": "S"
      }
  },
  {
      "id": 10,
      "name": "新竹縣",
      "is_supported": 0,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 11,
      "name": "苗栗縣",
      "is_supported": 0,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 12,
      "name": "彰化縣",
      "is_supported": 0,
      "fk_region_id": 2,
      "region": {
          "id": 2,
          "name": "中部",
          "no": "C"
      }
  },
  {
      "id": 13,
      "name": "南投縣",
      "is_supported": 0,
      "fk_region_id": 2,
      "region": {
          "id": 2,
          "name": "中部",
          "no": "C"
      }
  },
  {
      "id": 14,
      "name": "雲林縣",
      "is_supported": 0,
      "fk_region_id": 3,
      "region": {
          "id": 3,
          "name": "南部",
          "no": "S"
      }
  },
  {
      "id": 15,
      "name": "嘉義縣",
      "is_supported": 0,
      "fk_region_id": 3,
      "region": {
          "id": 3,
          "name": "南部",
          "no": "S"
      }
  },
  {
      "id": 16,
      "name": "屏東縣",
      "is_supported": 0,
      "fk_region_id": 3,
      "region": {
          "id": 3,
          "name": "南部",
          "no": "S"
      }
  },
  {
      "id": 17,
      "name": "宜蘭縣",
      "is_supported": 0,
      "fk_region_id": 1,
      "region": {
          "id": 1,
          "name": "北部",
          "no": "N"
      }
  },
  {
      "id": 18,
      "name": "花蓮縣",
      "is_supported": 0,
      "fk_region_id": 4,
      "region": {
          "id": 4,
          "name": "東部",
          "no": "E"
      }
  },
  {
      "id": 19,
      "name": "臺東縣",
      "is_supported": 0,
      "fk_region_id": 4,
      "region": {
          "id": 4,
          "name": "東部",
          "no": "E"
      }
  },
  {
      "id": 20,
      "name": "澎湖縣",
      "is_supported": 0,
      "fk_region_id": 5,
      "region": {
          "id": 5,
          "name": "外島",
          "no": "I"
      }
  },
  {
      "id": 21,
      "name": "金門縣",
      "is_supported": 0,
      "fk_region_id": 5,
      "region": {
          "id": 5,
          "name": "外島",
          "no": "I"
      }
  },
  {
      "id": 22,
      "name": "連江縣",
      "is_supported": 0,
      "fk_region_id": 5,
      "region": {
          "id": 5,
          "name": "外島",
          "no": "I"
      }
  }
]

export default cities


// WEBPACK FOOTER //
// ./src/constants/city.js